import React from 'react';
import { Card, Row, Col, Form, Select, DatePicker, Space, Button, Input } from 'antd';
import { FaFilter, FaSearch } from 'react-icons/fa';

const { RangePicker } = DatePicker;
const { Option } = Select;

const CustomerFilters = ({ 
  search, 
  statusFilter, 
  dateRange, 
  statusOptions, 
  filterVisible, 
  onSearchChange, 
  onStatusFilterChange, 
  onDateRangeChange, 
  onFilterToggle, 
  onResetFilters 
}) => {
  return (
    <>
      <div className="flex justify-between my-4 flex-wrap gap-3">
        <Space className="flex-wrap">
          <Input
            placeholder="Search by name, email or phone"
            prefix={<FaSearch />}
            value={search}
            onChange={onSearchChange}
            style={{ width: "300px" }}
          />
          <Button 
            icon={<FaFilter />} 
            onClick={onFilterToggle}
            type={filterVisible ? "primary" : "default"}
          >
            Filters
          </Button>
          {(search !== "" || statusFilter !== "All" || (dateRange && dateRange.length === 2)) && (
            <Button onClick={onResetFilters}>
              Clear Filters
            </Button>
          )}
        </Space>
      </div>

      {filterVisible && (
        <Card className="mb-4 bg-gray-50">
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12} lg={8}>
              <Form.Item label="Status Filter" className="mb-0">
                <Select
                  value={statusFilter}
                  onChange={onStatusFilterChange}
                  style={{ width: '100%' }}
                >
                  <Option value="All">All Statuses</Option>
                  {statusOptions.map(status => (
                    <Option key={status.value} value={status.value}>
                      {status.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={16}>
              <Form.Item label="Registration Date" className="mb-0">
                <RangePicker 
                  value={dateRange}
                  onChange={onDateRangeChange}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>
      )}
    </>
  );
};

export default CustomerFilters;